import { required, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

/**
 * ข้อมูลจด VAT ของร้าน — ร้านที่จด VAT ต้องกรอกครบทั้งชุด
 * เพราะทั้ง 3 ค่า (อัตรา + เลขผู้เสียภาษี + ชื่อตามทะเบียน) ต้องพิมพ์บนใบกำกับภาษี
 * (silver-spoon-api/docs/vat-compliance.md §2)
 */
export default function (formState) {
  const isVatRegistered = () => !!formState.tax_policy && formState.tax_policy !== 'no_tax';

  return {
    form: {
      tax_policy: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      vat_rate: {
        required: helpers.withMessage(i18n.global.t('Please enter a vat.'), requiredIf(isVatRegistered)),
      },
      tax_id: {
        required: helpers.withMessage(
          i18n.global.t('Please enter a tax ID.'),
          requiredIf(isVatRegistered)
        ),
        format: helpers.withMessage(
          i18n.global.t('Tax ID must be 13 digits.'),
          (value) => !helpers.req(value) || /^\d{13}$/.test(value)
        ),
      },
      tax_entity_name: {
        required: helpers.withMessage(
          i18n.global.t('Please enter the registered business name.'),
          requiredIf(isVatRegistered)
        ),
      },
    }
  }
};
